<ng-container *ngIf="detailData$ | async as detailData">
  <app-budged-section [detailData]="detailData"></app-budged-section>
  <hr />
</ng-container>
<app-spinner *ngIf="loading$ | async" [absoluteOverlay]="true"></app-spinner>
